{
  "version": 1,
  "asset_id": "ecdea7a8-8497-4a5e-9bb5-9261287a630f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/ecdea7a8-8497-4a5e-9bb5-9261287a630f/blog-default-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/ecdea7a8-8497-4a5e-9bb5-9261287a630f/blog-default-640.webp",
  "original_filename": "blog-default-640.webp",
  "size": 34324,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:51Z"
}
